import { StringUtil } from "@mcleod/core";
import { AutogenLayoutInvoiceProcessingOnHoldDialog } from "./autogen/AutogenLayoutInvoiceProcessingOnHoldDialog";

export class InvoiceProcessingOnHoldDialog extends AutogenLayoutInvoiceProcessingOnHoldDialog {
    private _headerText = "";
    
    onLoad() {
        if (this.headerText) {
            this.labelHeader.text = this.headerText;
        }
    }

    textboxOnHoldReasonCodeBeforeLookupModelSearch(event) {
        event.filter.code_type = "%B%";
        event.filter.is_active = "Y";
    }

    textboxOnHoldReasonCodeAfterLookup(event) {
        if (event?.selections?.length > 0) {
            this.textboxOnHoldDescription.enabled = true;
        } else {
            this.textboxOnHoldDescription.enabled = false;
            this.textboxOnHoldDescription.text = "";
        }
    }
    
    public get headerText() : string {
        return this._headerText;
    }
    
    public set headerText(input: string) {
        this._headerText = input;
    }
}